
import React, { useEffect } from 'react';
import { Header, Card, Grid, Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { getUsername, isAssociateManagerOrAbove, isSenior, canViewMaintenanceDashboard, isMaintenanceManager, isMaintenance, isICCSupport, canViewManagerDashboard, canViewAssetDashboard } from '../auth';
import { Footer } from "../footer";
import "../../css/common.css";
import {isAssociate, isReadOnly, userIsSafetyTeam, isSeniorView} from "../auth/Auth";

const HomePageCard = props => {
    const navigate = useNavigate()
    return <Card style={{ minHeight: "8rem", margin: "1rem", }} fluid
        header={<div style={
            {
                fontSize: "1.3rem",
                fontWeight: "bold",
                color: "black",
                display: "flex",
                justifyContent: "space-between"
            }
        }>
            <div>{props.header}</div>
            <Icon color="grey" className={props.icon} />
        </div>}
        description={props.description}
        onClick={() => navigate(props.href)} />
}

export const HomePage = () => {

    const navigate = useNavigate();

    useEffect(() => {
        if (isSenior() && !sessionStorage.getItem('has-opened-onestop')) {
            sessionStorage.setItem('has-opened-onestop', 'true')
            navigate('/onestop')
        }
    }, [])

    function hasPermission(name) {
        const permissions = {
            'members': (isReadOnly() && !isSeniorView()) || isAssociateManagerOrAbove() || isMaintenanceManager(),
            'teams': (isReadOnly() && !isSeniorView()) || isSenior() || isAssociateManagerOrAbove() || userIsSafetyTeam(),
            'assets': true,
            'subtypes': (isReadOnly() && !isSeniorView()) || isAssociateManagerOrAbove(),
            'readiness': (isReadOnly() && !isSeniorView()) || isSenior() || isAssociateManagerOrAbove(),
            'report': (isReadOnly() && !isSeniorView()) || isAssociateManagerOrAbove(),
            'onestop': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior(),
            'events': (isReadOnly() && !isSeniorView()) || isAssociateManagerOrAbove() || isMaintenanceManager(), // Maintenance managers can see absences
            'teamcalendar': (isReadOnly() && !isSeniorView()) || isAssociate() || isSenior() || isAssociateManagerOrAbove(),
            'standdown': !isMaintenance(), // Maintenance users cannot see standdown
            'profile': true,
            'documents': true,
            'forms': !isMaintenance(), // Maintenance users cannot see forms
            'maintenance': (isReadOnly() && !isSeniorView()) || canViewMaintenanceDashboard(),
            'contacts': true, // All associates can view
            'roadblock_report': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
            'asset_problem_report': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
            'future_readiness': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove() || isSenior(),
            'support': (isReadOnly() && !isSeniorView()) || isICCSupport() || isAssociateManagerOrAbove(),
            'manager_dashboard': (isReadOnly() && !isSeniorView()) || canViewManagerDashboard(),
            'asset_dashboard': isReadOnly() || canViewAssetDashboard(),
            'reporting_dashboard': isReadOnly() || isICCSupport() || isAssociateManagerOrAbove(),
        }
        return permissions[name]
    }

    return (
        <div className="homepage">
            <Header as='h2'>Internal Construction Crew Tool</Header>
            <Grid style={{ width: "70%" }} stackable>
                <Grid.Row>
                    {hasPermission('members') && <Grid.Column width={8}>
                        <HomePageCard header="Members" icon="user" href="/members"
                            description="View, edit and delete members. Members are anyone who is in the system."
                        />
                    </Grid.Column>}
                    {hasPermission('teams') && <Grid.Column width={8}>
                        <HomePageCard header="Teams" icon="users" href="/teams"
                            description="View, edit and delete teams. Teams consist of members."
                        />
                    </Grid.Column>}
                    {hasPermission('assets') && <Grid.Column width={8}>
                        <HomePageCard header="Assets" icon="truck" href="/assets"
                            description="View, edit and delete assets. Checklists for specific assets can also be found here."
                        />
                    </Grid.Column>}
                    {hasPermission('support') && <Grid.Column width={8}>
                        <HomePageCard header="Support" icon="cog" href="/support"
                            description="Support tools including Asset Subtypes and DFN management."
                        />
                    </Grid.Column>}
                    {hasPermission('readiness') && <Grid.Column width={8}>
                        <HomePageCard header="Readiness" icon="check" href="/readiness"
                            description="Submit team, asset and member readiness."
                        />
                    </Grid.Column>}
                    {hasPermission('report') && <Grid.Column width={8}>
                        <HomePageCard header="Readiness Report" icon="chart line" href="/readinessreport/team"
                            description="View a report of readiness across all teams, assets and members."
                        />
                    </Grid.Column>}
                    {hasPermission('events') && <Grid.Column width={8}>
                        <HomePageCard header="Absences" icon="calendar" href="/events"
                            description="View a list of all member's absences."
                        />
                    </Grid.Column>}
                    {hasPermission('teamcalendar') && <Grid.Column width={8}>
                        <HomePageCard header="Team Calendar" icon="calendar alternate" href="/teamcalendar"
                            description="View team calendar events and request time off."
                        />
                    </Grid.Column>}
                    {hasPermission('onestop') && <Grid.Column width={8}>
                        <HomePageCard header="Onestop" icon="checked calendar" href="/onestop"
                            description="Daily check-in."
                        />
                    </Grid.Column>}
                    {hasPermission('profile') && <Grid.Column width={8}>
                        <HomePageCard header="Profile" icon="user" href={"/members/" + getUsername() + "/schedule"}
                            description="Your member page and schedule."
                        />
                    </Grid.Column>}
                     {hasPermission('standdown') && <Grid.Column width={8}>
                         <HomePageCard header="Monthly Stand-Down" icon="tags" href="/standdown"
                            description="Create, Edit and View stand-down."
                        />
                    </Grid.Column>}
                    {hasPermission('forms') && <Grid.Column width={8}>
                         <HomePageCard header="Forms" icon="tags" href="/forms"
                            description="Create, Edit and View all Forms."
                        />
                    </Grid.Column>}
                    {hasPermission('maintenance') && <Grid.Column width={8}>
                         <HomePageCard header="Maintenance Dashboard" icon="wrench" href="/maintenance"
                            description="View and manage asset problems marked as out of service or under maintenance."
                        />
                    </Grid.Column>}
                    {hasPermission('documents') && <Grid.Column width={8}>
                         <HomePageCard header="Documents" icon="file" href="/documents"
                            description="View and manage all Foreman training checklists."
                        />
                    </Grid.Column>}
                    {hasPermission('contacts') && <Grid.Column width={8}>
                         <HomePageCard header="Contacts Hub" icon="address book" href="/contacts"
                            description="View important contact information for various departments."
                        />
                    </Grid.Column>}
                    {hasPermission('roadblock_report') && <Grid.Column width={8}>
                         <HomePageCard header="Roadblocks Report" icon="chart bar" href="/roadblock/report"
                            description="View analytics and performance metrics for roadblocks."
                        />
                    </Grid.Column>}
                    {hasPermission('asset_problem_report') && <Grid.Column width={8}>
                         <HomePageCard header="Asset Problem Report" icon="exclamation triangle" href="/manager/asset-problem-report"
                            description="View analytics and drill down into asset problems by state, market, and team."
                        />
                    </Grid.Column>}
                    {hasPermission('future_readiness') && <Grid.Column width={8}>
                         <HomePageCard header="Future Readiness Planning" icon="calendar check outline" href="/readiness/planning"
                            description="View member availability, assets out of service, and open roadblocks by team for a future date range."
                        />
                    </Grid.Column>}
                    {hasPermission('manager_dashboard') && <Grid.Column width={8}>
                         <HomePageCard header="Manager Dashboard" icon="dashboard" href="/manager/dashboard"
                            description="View all teams, members, assets, roadblocks, and scheduled moves at a glance."
                        />
                    </Grid.Column>}
                    {hasPermission('asset_dashboard') && <Grid.Column width={8}>
                         <HomePageCard header="Asset Dashboard" icon="truck" href="/assets/dashboard"
                            description="View asset health, open problems and stand-downs across your teams."
                        />
                    </Grid.Column>}
                    {hasPermission('reporting_dashboard') && <Grid.Column width={8}>
                         <HomePageCard header="Reporting Dashboard" icon="dashboard" href="/dashboard"
                            description="View asset downtime, maintenance cost, team member turnover, readiness, percentage fully staffed per team and number of barrier issues."
                        />
                    </Grid.Column>}
                </Grid.Row>
            </Grid>
            <Footer />
        </div>
    );
};
